import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'energy_i_e_fuel_coal_electricity_gas_etc'

export const dataPointDefinition = {
  retracedId: 'energy_i_e_fuel_coal_electricity_gas_etc',
  name: 'Energy (i.e. fuel, coal, electricity, gas etc.)',
  description: '"Energy" refers to types of energy that are provided for free OR at a lower cost by the facility. ',
  meta: {
    slcpMeta: {
      key: 'wb-22--2-6x',
      number: 'WB-WAGE-143-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-22--2-6x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35350,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
